import { Outlet } from 'react-router'
import { Box } from '@mui/material'
import { NavigationView } from 'Features/Projects/Navigation.view'

export const ProjectLayout = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        flex: 'auto',
        height: '80vh',
      }}
    >
      <Box display="flex" flexDirection="column" height="100%">
        <NavigationView />
      </Box>
      <Box display="flex" flex="auto">
        <Outlet />
      </Box>
    </Box>
  )
}
